import awsdk from 'awsdk';

// ON_TIME
// EARLY
// LATE
// NO_PROVIDER

export const CheckInStatus = awsdk.AWSDKCheckInStatus;
export type CheckInStatus = typeof CheckInStatus;
